import styled from "styled-components";

export const Header = styled.div<{
  backgroundColor: string;
  color: string;
  otherColors: string[];
}>`
  display: flex;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
  padding: 12px;
  margin-left: -12px;
  margin-right: -12px;
  margin-bottom: 12px;
  position: sticky;
  top: 0;
  z-index: 3;
  height: 56px;
  &:before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 56px;
    height: 56px;
    z-index: 0;
    background: ${({ otherColors, backgroundColor }) => {
      const list = [backgroundColor, ...otherColors].map((col, index) => {
        return `${col} ${(index * 100) / (otherColors.length + 2)}%, ${col} ${
          ((index + 2) * 100) / (otherColors.length + 2)
        }%`;
      });

      return `
      repeating-linear-gradient(
        -45deg,
        ${list.join(",")}
      )
    `;
    }};
  }
  &:after {
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    position: absolute;
    z-index: 0;
    background-color: #00012108;
    content: " ";
  }
`;
export const HeaderLeft = styled.div`
  margin-right: 8px;
  position: relative;
  z-index: 1;
`;
export const HeaderText = styled.div`
  font-weight: bold;
  position: relative;
  z-index: 1;
  text-align: left;
  flex-grow: 1;
`;
export const HeaderRight = styled.div`
  position: relative;
  z-index: 1;
`;

export const RightMenu = styled.ul<{ isVisible: boolean }>`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 100%;
  margin-top: 8px;
  right: 0;
  background-color: white;
  box-shadow: 0 3px 10px #00012155;
  border-radius: 8px;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? "all" : "none")};
`;
export const RightMenuItem = styled.li`
  min-height: 48px;
  padding: 12px 16px;
  white-space: nowrap;

  & + & {
    border-top: 1px solid #0002;
  }

  &:active {
    opacity: 1;
    pointer-events: all;
  }
`;
